// A tiny pub/sub bridge between the always-mounted RealtimeVoiceOrb (global, floats over
// every page once logged in) and the Landing page's mothership ship-launch logic. When Doc
// says "open OCTON Retina" to AVA, the orb calls `landingLaunchBridge.current(project)` if
// Landing is currently mounted (so the full cinematic undock/whoosh/liftoff plays), or falls
// back to opening the project's tab directly if Landing isn't the active page.
export const landingLaunchBridge = { current: null };

// Same idea for fleet status: Landing registers a getter returning the live voyage list
// (projects launched from the mothership whose tabs are still open), so AVA's voice orb
// can answer "which ships are out?" with the real state instead of guessing.
export const voyageStatusBridge = { current: null };

// Bay tour: Landing registers a starter that kicks off the visual fly-over (a spotlight
// sweeping bay to bay) and returns the ordered roster for AVA to narrate in sync.
export const bayTourBridge = { current: null };

// Voice-live session handle exposed by the always-mounted RealtimeVoiceOrb so other
// components (specifically the Landing launcher) can gracefully shut the mothership
// voice down BEFORE the launched project comes up with its own local voice - avoids
// crazy double-voice-over talking over Doc from two AVA instances at once.
export const voiceDisconnectBridge = { current: null };

// Launch handoff: instead of abruptly severing the voice link on launch, the orb
// registers a handler that makes AVA announce "handing off to [Project]'s own voice"
// out loud, THEN disconnects a few seconds later. Returns true when the announcement
// will play (session live), false when there's nothing to hand off.
export const voiceHandoffBridge = { current: null };
